import React, { Component } from "react";
import styled from "styled-components";
import classNames from "classnames";
import _ from "lodash";

import { MdLock } from "react-icons/md";

import Loader from "../components/general/Loader";
import Toolbar from "../components/Toolbar";
import Button from "../components/general/Button";

const Locked = () => {
  return (
    <LockedWrapper className="locked-overlay">
      <LockedWrapperContent>
        <MdLock />
        <p style={{ margin: "20px 0 30px 0", display: "inline-block" }}>
          This item is locked in the demo preview. Please purchase Shards Pro to
          get access to the entire library of components and landing pages.
        </p>
        <Button href="https://designrevision.com/downloads/shards-pro#pricing">Buy Now</Button>
      </LockedWrapperContent>
    </LockedWrapper>
  );
};

const LockedWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.9);
  opacity: 0;
  transition: opacity 300ms ease-in-out;
  border-radius: 10px;
`;

const LockedWrapperContent = styled.div`
  display: table;
  position: absolute;
  width: 50%;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  color: #fff;

  @media (max-width: 800px) {
    font-size: 10px;
    width: 100%;
  }

  svg {
    transform: scale(2);
  }
`;

class ElementWrapper extends Component {
  constructor(props) {
    super(props);

    this.iframeRef = React.createRef();
    this.resizeEvent = null;

    this.handleResize = this.handleResize.bind(this);
  }

  render() {
    const { element, idx, categoryIdx, state } = this.props;
    return (
      <ElWrapper className={classNames(element.classes)} id={`item-${idx}`} style={element.styles}>
        <FrameWrapper style={element.styles}>
          {element.locked ? (<img alt={element.dir} className="demo-image-preview" src={`${process.env.REACT_APP_DEMO_IMAGE_PREVIEWS_URL}${element.preview}`} title="" />) : (
            <iframe
              ref={this.iframeRef}
              id={`frame-${idx}`}
              onLoad={this._iframeLoaded.bind(this)}
              className="element-frame"
              title={element.dir}
              frameBorder="0"
              data-index={idx}
              data-cindex={categoryIdx}
              data-src={`${process.env.REACT_APP_DEMO_URL}${element.src}`}
            />
          )}
        </FrameWrapper>
        <Loader loaded={element.loaded || element.locked} />
        {element.locked && <Locked />}
        {!element.locked && <Toolbar catIdx={categoryIdx} elIdx={idx} app={state} />}
      </ElWrapper>
    );
  }

  _iframeLoaded(el) {
    if (
      el.target.contentDocument &&
      !el.target.contentDocument.body.children.length
    )
      return;

    this.props.state.setElementAsLoaded(
      el.target.dataset.index,
      el.target.dataset.cindex
    );

    window.addEventListener('resize', this.handleResize(this.iframeRef));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize());
  }

  handleResize(iframe) {
    return _.throttle(function() {
      // console.log(iframe.current.contentWindow.document.body.firstElementChild)
      // document.getElementsByTagName('body')[0].firstElementChild.offsetHeight
      // todo: resize the iframe to have the same height of the first content element
    }, 300);
  }
}

export default ElementWrapper;

const ElWrapper = styled.div`
  width: 100%;
  transition: all 250ms ease-in-out;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.02), 0 3px 10px rgba(0, 0, 0, 0.05);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  position: relative;
  border-radius: 10px;
  max-width: 1350px;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.03), 0 5px 15px rgba(0, 0, 0, 0.1);

    .toolbar {
      transform: translate(-50%, 0);
      opacity: 1;

      @media screen and (max-width: 700px) {
        display: none !important;
      }
    }

    .locked-overlay {
      opacity: 1;
    }
  }

  iframe {
    width: 100%;
    height: 100%;
  }

  &.laptop {
    max-width: 1350px;
  }

  &.tablet {
    max-width: 768px;
  }

  &.smartphone {
    max-width: 375px;
  }
`;

const FrameWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
`;
